<template>
  <div class="conteudoTable">
            <p  class="txtDadosG">Dados do Emitente</p>
            <div class="dadosGerais">
                <div style="flex-direction:column; width:49%;">
                    <div v-for="(n,i) in table.emitente_e" :key="i" :style="{'width':n.tamanho+'%', 'margin-top':7+'px'}"> 
                        <label for="">{{n.nome}}</label><br>
                        <input type="text" v-model="n.dado" >
                    </div>
                </div>
                <div style="flex-direction:column;width:49%;">
                    <div v-for="(n,i) in table.emitente_d" :key="i" :style="{'width':n.tamanho+'%', 'margin-top':7+'px'}"> 
                        <label for="">{{n.nome}}</label><br>
                        <input type="text" v-model="n.dado" >
                    </div>
                </div>
            </div>
  </div>
</template>

<script>
export default {
    props:['table'],
    data(){
        return{
            
        }
    },
    

}
</script>

<style>

</style>